<div class="container sub-header__container" fxLayoutAlign="space-between center">
  <div class="title">
    <ng-content></ng-content>
    {{title}} <img class="beta-icon" *ngIf="icon" src="{{icon}}" height="22" width="38" alt="beta">
  </div>

  <ng-container *ngTemplateOutlet="widgets"></ng-container>

  <ng-container *ngIf="showHeader">
    <app-qc-status [session]="(sessionFiltered$ | async)" class="qc-status"></app-qc-status>
  </ng-container>

  <div class="selectors" fxLayoutAlign="start center">
    <ng-template alpha-filters></ng-template>
  </div>
</div>
